import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { UserProxy } from 'src/app/core/store/user/user.proxy';

@Component({
  selector: 'logout-listener',
  template: ''
})
export class LogoutListenerComponent {

  @HostListener('document:visibilitychange', ['$event'])
  appVisibility() {
    if (!document.hidden) {
      this.activatedRoute.queryParams.pipe(take(1)).subscribe(async queryParams => {
        if (queryParams && queryParams['stateUrl'] && queryParams['email']) {
          await this.userProxy.getUser();
          this.userProxy.userEmail$.pipe(take(1)).subscribe(userEmail => {
            if (userEmail === queryParams['email']) {
              this.router.navigate([queryParams['stateUrl']]);
            } else {
              this.router.navigate(['./']);
              setTimeout(() => location.reload());
            }
          });
        } else {
          this.router.navigate(['./']);
          setTimeout(() => location.reload());
        }
      })
    }
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userProxy: UserProxy
  ) {
  }

}
